import React, { Component } from 'react';

import sharedStyles from '../sharedStyles.scss';

class TwoColumnTable extends Component {
  render() {
    const { title, records } = this.props;

    return (
      <div className={sharedStyles.childLayout}>
        {title && <div className={sharedStyles.header}>{title}</div>}
        <div className={sharedStyles.responsiveTable}>
          {records.map((record, i) => (
            <div key={i} className={sharedStyles.responsiveTableSection}>
              <div className={sharedStyles.responsiveTableTopic}>{record.topic}</div>
              <div className={sharedStyles.responsiveTableDescription}>
                {record.description}
              </div>
              {record.weight && (
                <div className={sharedStyles.responsiveTableSummary}>{record.weight}</div>
              )}
            </div>
          ))}
        </div>

        <table className={sharedStyles.table}>
          <thead>
            <tr>
              <th>Topic</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {records.map((record, i) => (
              <tr key={i}>
                <td>
                  <div className={sharedStyles.topic}>{record.topic}</div>
                  {record.weight && (
                    <div className={sharedStyles.summary}>{record.weight}</div>
                  )}
                </td>
                <td>{record.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default TwoColumnTable;
